module.exports = __webpack_public_path__ + "img/lego.f5f34ee2.svg";